import { FC } from 'react';
import { ProductGuideStoryblok } from 'storyblok-types';
import { Container } from 'atoms/Container';
import { renderLink } from 'atoms/StoryBlokLink';
import { H2 } from 'atoms/Typography';
import { Item } from 'pages/StoryBlok/ProductGuide/Item';
import { renderRichText } from 'modules/stroyblok/services';
import styles from './styles.module.css';

export const ProductGuide: FC<{ blok: ProductGuideStoryblok }> = ({ blok }) => {
  return (
    <Container id={blok?.id} className={styles.container}>
      {blok?.title && <H2 className={styles.title}>{blok.title}</H2>}
      {!!blok?.items?.length && (
        <ul className={styles.list}>
          {blok?.items?.map((item) => (
            <li key={item._uid}>
              <Item
                data={item}
                href={renderLink(item.link)}
                description={
                  item?.description && renderRichText(item.description)
                }
              />
            </li>
          ))}
        </ul>
      )}
    </Container>
  );
};
